module.exports = __webpack_public_path__ + "static/img/ios-ewm.0334023.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ios-ewm.png
// module id = Wz7m
// module chunks = 8